'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Values are use in multi-quote. May need to redeploy multi-quote if the values
// are changed.

var age = exports.age = {
  min: 17,
  max: 34
};
var vehicleValue = exports.vehicleValue = {
  min: 100,
  max: 30000
};
var IS_LIVE_SITE = exports.IS_LIVE_SITE = process.env.REACT_APP_DEPLOY_ENVIRONMENT === 'production';